export default __webpack_public_path__ + "media/images/screen_interactions-4de710fdf37a699e5ca396d7a08e6bd7.svg";